import ApiCore from "../utilities/core";
import axios from "axios";

const url = 'reports';
const plural = 'reports';
const single = 'reports';

// plural and single may be used for message logic if needed in the ApiCore class.

export const apiReports = new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    patch: true,
    delete: false,
    url: url,
    plural: plural,
    single: single,
    requireToken: true
});

// Override getAll to handle binary Excel file responses
apiReports.getAll = (query = "") => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    let token = localStorage.getItem('token');
    
    return axios.get(`${BASE_URL}/${url}${query ? '?' + query : ''}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
        },
        responseType: 'blob' // Important: set responseType to blob for binary data
    }).then(response => {
        return response.data; // Return the blob data directly
    }).catch(error => {
        throw error;
    });
};

apiReports.massUpdate = () => {
    // Add custom api call logic here
}